'use strict';

var toString = Object.prototype.toString;

/**
 * Array.isArray polyfill wrapper
 *
 * @type {Function}
 */
module.exports = Array.isArray || function (value) {
    return toString.call(value) === '[object Array]';
};
